import { Column, Row } from '@/components'
import { themeBreakpointDown } from '@/utils/theme'
import styled from 'styled-components'

export const TableContainer = styled(Column)<{ hasData: boolean }>`
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.b30};
  background-color: ${(props) => props.theme.color.b0};
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: ${({ hasData }) => (hasData ? '56px' : '0')};
  > div:first-child {
    width: 100%;
    padding: 16px 16px 0 16px;
  }

  > div:first-child span {
    white-space: normal;
  }

  /* table-layout: fixed pins Status/Insurance/Policy Number to a narrow,
     fixed width so the Title column absorbs whatever space is left. */
  table {
    table-layout: fixed;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 140px;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 320px;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 240px;
  }
`

export const TableCell = styled.div<{
  margin?: string
  cursor?: string
  width?: string
}>`
  display: flex;
  margin: ${({ margin }) => margin || '0'};
  align-items: center;
  gap: 8px;
  cursor: ${({ cursor }) => cursor || 'inherit'};
  width: ${({ width }) => width || 'auto'};
`

export const StyledRelativeContainer = styled.div`
  position: relative;
`

export const TitleCellContainer = styled(Row)`
  align-items: center;
  gap: 8px;
  cursor: pointer;
  width: 100%;
  min-width: 0;

  svg {
    flex-shrink: 0;
    > path {
      stroke: ${(props) => props.theme.color.b40};
    }
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.color.b40};
    outline-offset: 2px;
    border-radius: 4px;
  }
`

export const InsuranceCellContainer = styled(Row)`
  padding: 0 8px 0 0;
  cursor: pointer;
  align-items: center;
  gap: 8px;
  width: 100%;

  img {
    flex-shrink: 0;
  }

  ${themeBreakpointDown('sm')} {
    padding: 16px 8px 0 0;
    min-width: 200px;
    flex-wrap: no-wrap;
  }
`

export const InsuranceCellTextContainer = styled(Column)`
  min-width: 0;
  overflow: hidden;

  svg {
    flex-shrink: 0;
    margin-left: 5px;
    > path {
      stroke: ${(props) => props.theme.color.b40};
    }
  }
`

export const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${(props) => props.theme.color.info1};
`
